module.exports = __webpack_public_path__ + "182bd80608e761f38e46e0b37700f9d2.pdf";